import { InlineBlock, InlineFlex } from '@components/Layout/Blocks';
import { SummaryContext } from '@components/SummarySelection/context';
import { selectItemsFromState } from '@components/SummarySelection/data/selectors';
import STYLE from '@components/SummarySelection/style';
import { SummaryPreviewCard } from '@components/SummarySelection/SummaryPreviewCard';
import { useMediaQuery } from '@hooks/useMediaQuery';
import { Package } from '@model/Package';
import { Sku } from '@model/Sku';
import { createMemo } from '@packages/react';
import React, { useCallback, useContext } from 'react';

export const SummaryPreview = createMemo(
    () => {
        const [state, actions] = useContext(SummaryContext);
        const isMobile = useMediaQuery('mobile');

        const items = selectItemsFromState(state);

        const handleItemRemove = useCallback(
            (data) => {
                if (data.type === Package) {
                    actions.selectPackage(data.value);
                } else if (data.type === Sku) {
                    actions.toggleSku(data.value);
                }
            },
            [''],
        );

        const handlePackageItemChange = useCallback(
            (data, skus) => {
                actions.editPackage({ item: data, skus });
            },
            [''],
        );

        return (
            <InlineBlock
                style={STYLE.summaryBar.previewContainer}
                w={'100%'}
                maxWidth={'100%'}
                p={isMobile ? '14px' : '20px 30px'}
            >
                <InlineFlex minWidth={'100%'}>
                    {items.map((item) => (
                        <SummaryPreviewCard
                            key={`${item.type === Package ? 'package' : 'sku'}_${item.id}`}
                            item={item}
                            onRemove={handleItemRemove}
                            onItemChange={handlePackageItemChange}
                        />
                    ))}
                </InlineFlex>
            </InlineBlock>
        );
    },
    {
        displayName: 'SummaryPreview',
    },
);
